import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { product, email } = location.state || {};

  const handleRazorpay = async () => {
    if (!product) {
      alert("No product found.");
      return;
    }

    // 1️⃣ Create Razorpay Order from Hostinger backend
    const orderResponse = await fetch("https://jivangaming.in/api/create_order.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: product.price * 100, // in paise
      }),
    });

    const orderData = await orderResponse.json();

    if (!orderData.success) {
      alert("Failed to create order. Try again.");
      return;
    }

    // 2️⃣ Razorpay Checkout Options
    const options = {
      key: "rzp_live_wiSDsxIkTdy6s8",
      amount: orderData.amount,
      currency: "INR",
      name: "Course Payment",
      description: product.name,
      order_id: orderData.orderId,  // 🔥 REQUIRED OR PAYMENT AUTO REFUNDS

      handler: function (response) {
        fetch("https://jivangaming.in/api/send_email.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            productName: product.name,
            userEmail: email,
          }),
        })
          .then((res) => res.json())
          .then(() => {
            alert("Payment successful! 🎉 Email sent.");
            navigate("/");
          })
          .catch(() => {
            alert("Payment was captured, but email sending failed.");
          });
      },

      theme: {
        color: "#000",
      },
    };

    // 3️⃣ Open Razorpay Checkout
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <div className="max-w-xl mx-auto p-8">
      <h2 className="text-2xl font-bold mb-6">
        Payment for {product?.name}
      </h2>
      <p className="mb-4">Price: Rs. {product?.price}</p>

      <button
        onClick={handleRazorpay}
        className="bg-black text-white w-full py-3 rounded hover:bg-gray-800"
      >
        Pay with Razorpay
      </button>
    </div>
  );
};

export default Payment;
